import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

interface Props {
  error: string;
}

const useStyles = makeStyles(() => ({
  error: { display: 'inline', color: 'red' },
}));

export default function FormInputErrorMessage({ error }: Props) {
  const classes = useStyles();
  return (
    <Typography variant="caption" className={classes.error}>
      {error && error}
    </Typography>
  );
}
